import { cmsContent } from './content';
import { sanitizeHtml } from '../../utils';

export interface Indexable {
  [key: string]: any;
}
const getContent = (contentId: string): any =>
  (cmsContent as Indexable)[contentId].content;

/**
 * @description Retrieve CMS content
 * @param id string content identifier
 * @param sanitize boolean If the content includes html, clean and protect against xss
 */
export const useCmsContent = ({
  id,
  sanitize = true,
}: {
  id: string;
  sanitize?: boolean;
}): any => {
  if (!(id in cmsContent)) {
    return null;
  }
  const rawContent = getContent(id);
  return sanitize ? sanitizeHtml(rawContent) : rawContent;
};
